import { useEffect, useState } from "react";
import Navbar from "../Navbar";
import "./Menu.css";
import AddMenuModal from "./Addmenumodal";
import OfferModal from "./OfferModal";
import { BACKEND_URL } from "../../../services/Helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import secimage from "../../../Assets/hero.jpg";

function ConfirmModal({ title, sub, confirmLabel = "Yes, Delete", onConfirm, onCancel }) {
    return (
        <div className="confirm-overlay" onClick={onCancel}>
            <div className="confirm-card" onClick={e => e.stopPropagation()}>
                <div className="confirm-icon">🗑️</div>
                <div className="confirm-title">{title}</div>
                {sub && <div className="confirm-sub">{sub}</div>}
                <div className="confirm-btns">
                    <button className="confirm-yes" onClick={onConfirm}>{confirmLabel}</button>
                    <button className="confirm-no" onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

const Menu = () => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [allmenu, setAllMenu] = useState([]);
    const [deletingId, setDeletingId] = useState(null);
    const [confirmModal, setConfirmModal] = useState(null);
    const [editingMenu, setEditingMenu] = useState(null);
    const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
    const [selectedMenuId, setSelectedMenuId] = useState(null);

    const fetchMyMenu = async () => {
        try {
            const token = localStorage.getItem("shoplogintoken");
            if (!token) {
                toast.error("You must be logged in to get your menu");
                navigate("/shoplogin");
                return;
            }
            const res = await fetch(`${BACKEND_URL}/nearbe/mymenu`, {
                method: "GET",
                headers: { Authorization: token },
            });
            const data = await res.json();
            setAllMenu(data.myMenu);
        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong!");
        }
    };

    useEffect(() => {
        fetchMyMenu();
    }, []);

    const handleDelete = async (menuId) => {
        try {
            setDeletingId(menuId);
            const token = localStorage.getItem("shoplogintoken");
            const res = await fetch(`${BACKEND_URL}/nearbe/deletemenuitem/${menuId}`, {
                method: "DELETE",
                headers: { Authorization: token },
            });
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.message || "Delete failed");
                return;
            }
            toast.success("Menu item deleted");
            setAllMenu((prev) => prev.filter((menu) => menu._id !== menuId));
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong!");
        } finally {
            setDeletingId(null);
        }
    };

    const handleDeleteOffer = async (menuId) => {
        try {
            const token = localStorage.getItem("shoplogintoken");
            const res = await fetch(`${BACKEND_URL}/nearbe/menu/${menuId}/deleteoffer`, {
                method: "PUT",
                headers: { Authorization: token },
            });
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.message || "Remove offer failed");
                return;
            }
            toast.success("Offer removed");
            setAllMenu((prev) =>
                prev.map((m) => (m._id === menuId ? data.updatedMenu : m))
            );
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong!");
        }
    };

    return (
        <div className="menuhai">
            <Navbar />
            <div className="menu_contain">
                <div className="upper-part">
                    <h2>Menu Management</h2>
                    <button className="add-btn" onClick={() => setIsModalOpen(true)}>
                        + Add Menu Item
                    </button>
                </div>

                <div className="menu-item">
                    {allmenu.length === 0 ? (
                        <p className="no-offer-msg">🚫 No menu items yet — add your first one!</p>
                    ) : (
                        allmenu.map((menu) => (
                            <div className="card" key={menu._id}>
                                <div className="card-image">
                                    <img src={menu?.itemImage || secimage} alt="Menu" />
                                </div>
                                <div className="card-content">
                                    <h3>
                                        {menu?.itemName}{" "}
                                        {menu?.offerPercentage ? (
                                            <span className="offerper">{menu.offerPercentage}% OFF</span>
                                        ) : null}
                                    </h3>
                                    <p className="item-quantity">{menu?.itemdescription}</p>
                                    <div className="price-status">
                                        <span className="price">Rs-{menu?.itemPrice}</span>
                                        <span className="menustatus_available">{menu?.availability}</span>
                                    </div>
                                    <div className="extra-info">
                                        Preparation Time : <span>⏱ {menu?.prepTime} mins</span>
                                    </div>
                                    <div className="card-actions">
                                        <button
                                            className="edit-btn"
                                            onClick={() => {
                                                setEditingMenu(menu);
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            Edit
                                        </button>

                                        {menu.offerPercentage ? (
                                            <button
                                                className="offer-btn"
                                                onClick={() => setConfirmModal({
                                                    type: "removeOffer",
                                                    id: menu._id,
                                                    name: menu.itemName,
                                                })}
                                            >
                                                Remove Offer
                                            </button>
                                        ) : (
                                            <button
                                                className="offer-btn"
                                                onClick={() => {
                                                    setSelectedMenuId(menu._id);
                                                    setIsOfferModalOpen(true);
                                                }}
                                            >
                                                Add Offer
                                            </button>
                                        )}

                                        <button
                                            className="delete-btn"
                                            onClick={() => setConfirmModal({
                                                type: "deleteItem",
                                                id: menu._id,
                                                name: menu.itemName,
                                            })}
                                            disabled={deletingId === menu._id}
                                        >
                                            {deletingId === menu._id ? "Deleting..." : "Delete"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {isModalOpen && (
                <AddMenuModal
                    onClose={() => {
                        setIsModalOpen(false);
                        setEditingMenu(null);
                    }}
                    onMenuAdded={(newMenu) => setAllMenu((prev) => [newMenu, ...prev])}
                    onMenuUpdated={(updatedMenu) =>
                        setAllMenu((prev) =>
                            prev.map((m) => (m._id === updatedMenu._id ? updatedMenu : m))
                        )
                    }
                    editingMenu={editingMenu}
                />
            )}

            {isOfferModalOpen && selectedMenuId && (
                <OfferModal
                    menuId={selectedMenuId}
                    onClose={() => {
                        setIsOfferModalOpen(false);
                        setSelectedMenuId(null);
                    }}
                    onOfferAdded={(updatedMenu) =>
                        setAllMenu((prev) =>
                            prev.map((m) => (m._id === updatedMenu._id ? updatedMenu : m))
                        )
                    }
                />
            )}

            {confirmModal && (
                <ConfirmModal
                    title={
                        confirmModal.type === "deleteItem"
                            ? `Delete "${confirmModal.name}"?`
                            : `Remove offer from "${confirmModal.name}"?`
                    }
                    sub={
                        confirmModal.type === "deleteItem"
                            ? "This item will be permanently removed from your menu."
                            : "The item will stay but the discount will be removed."
                    }
                    confirmLabel={confirmModal.type === "deleteItem" ? "Yes, Delete" : "Yes, Remove"}
                    onConfirm={() => {
                        const { type, id } = confirmModal;
                        setConfirmModal(null);
                        if (type === "deleteItem") handleDelete(id);
                        else handleDeleteOffer(id);
                    }}
                    onCancel={() => setConfirmModal(null)}
                />
            )}
        </div>
    );
};

export default Menu;
